import React, {useEffect, useState} from 'react';
import {Portlet, PortletBody, PortletHeader} from "./Portlet";
import BlockUi from "@availity/block-ui";
import axios from "../helpers/axios";
import _ from "lodash"
import {Table} from "reactstrap";

const StatusFrom1C = ({dataTickets}) => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)
  console.log('dataTickets',dataTickets)

  useEffect(() => {
    if (dataTickets.length >0){
      setLoading(true)
      axios.post("/api/fromOneC/entitiesStatus",{entities: dataTickets})
        .then(({data})=>{
          setData(data.data.data)
          console.log("entitiesStatus",data.data.data)
        })
        .finally(()=>setLoading(false))
    }
  }, []);
  return (
    <BlockUi blocking={loading}>
      <Portlet>
        <PortletHeader title={'Статус из 1с'}/>
        <Table striped bordered size={'sm'}>
          <thead>
          <tr>
            <td>№</td>
            <td>Проведен</td>
            <td>Удален</td>
          </tr>
          </thead>
          <tbody>
          {data && dataTickets.map((item,i)=>{
            const findItem = _.find(data, {code:item.code})
            return <tr key={i}>
              <td>{item.code}</td>
              {findItem ? <>
                  <td className={'text-center'}>{findItem.posted ? "Да" : "Нет"}</td>
                  <td className={'text-center'}>{findItem.deleted ? "Да" : "Нет"}</td>
                </> :
                <td colSpan={2} className={'text-center'}>Не найден в 1с</td>}
            </tr>
          })}
          </tbody>
        </Table>

      </Portlet>
    </BlockUi>
  );
};

export default StatusFrom1C;
